import React from 'react';
const rio = require('../assets/rio.jpg');
export default class LoadingResources extends React.Component {

    render() {
        return (
            <div className="appLoading">
                <h3>Loading application...</h3>
                <div className="rio">
                    <img
                        className="rio"
                        src={rio}
                        aria-hidden
                        alt="background image"
                    />
                </div>




                <div className="appLoadingText">

                    <h1>Loading resources ...</h1>
                    <br/><br/><br/><br/><br/><br/><br/><br/>
                    <p>
                        By Cloud Computing Group 22
                    </p>
                    <p>
                        Asignment 2
                    </p>
                    <p>

                    </p>
                </div>


            </div>
        )
    }
}


